module.exports = __webpack_public_path__ + "static/media/rocket.c5bc71a7.svg";